<template><landing /></template>
<script>
import Landing from './Landing.vue';
import { setPresentation } from './presentation';
export default {
  components: { Landing },
  created() { setPresentation(true); }
};
</script>
